var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SubscriberService from "../../Subscriber/services/SubscriberService";
import { Can } from "../../App/utils/Authorize";
import SubscriberForm from "../components/SubscriberForm";
import ConfirmForm from "../components/ConfirmForm";
import Title from "../../App/components/Title";
import Breadcrumbs from "../../App/components/Breadcrumbs";
import Notification from "../../App/components/Notification";
import "../styles/UpdateSubscriber.css";
import "../styles/SubscriberActivity.css";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { handleServiceError } from "../../App/components/ErrorHandler";
import useAuth from "../../App/hooks/useAuth";
import MuiIcon from "../../App/components/MuiIcon";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import Overlay from "../../App/components/Overlay";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getTokenStatusConfigById } from "../../App/utils/tokenStatusUtils";
var EMAIL_STATUS_COLORS = {
    "Na fila para envio": "#F9A825",
    Enviando: "#F9A825",
    Enviado: "#388E3C",
    "Erro no envio": "#F24C4C",
    "Envio cancelado": "#F24C4C",
};
var EMAIL_ERROR_STATUS = ["Erro no envio", "Envio cancelado"];
function getEmailStatusColor(statusName) {
    var _a;
    return (_a = EMAIL_STATUS_COLORS[statusName]) !== null && _a !== void 0 ? _a : "#6C757D";
}
function HistoryTable(_a) {
    var title = _a.title, columns = _a.columns, rows = _a.rows, renderRow = _a.renderRow, emptyMessage = _a.emptyMessage, wrapperStyle = _a.wrapperStyle;
    return (_jsxs("div", __assign({ className: "container-subscriber container-settings", style: wrapperStyle }, { children: [_jsx("h3", { children: title }), _jsx("div", __assign({ className: "d-flex justify-content-center", style: { marginTop: "1.5rem" } }, { children: _jsxs("table", __assign({ className: "table-hover container-table-subscriber-activity" }, { children: [_jsx("thead", { children: _jsx("tr", { children: columns.map(function (column) {
                                    var _a;
                                    return (_jsx("th", __assign({ className: (_a = column.className) !== null && _a !== void 0 ? _a : "titles-table-subscriber-activity", style: column.style }, { children: column.label }), column.label));
                                }) }) }), _jsx("tbody", { children: rows.length > 0 ? (rows.map(function (row, index) { return renderRow(row, index); })) : (_jsx("tr", { children: _jsx("td", __assign({ colSpan: columns.length, className: "text-center" }, { children: emptyMessage })) })) })] })) }))] })));
}
function handleAction(selectedAction, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = selectedAction;
                    switch (_a) {
                        case "activate": return [3 /*break*/, 1];
                        case "reactivate": return [3 /*break*/, 1];
                        case "suspend": return [3 /*break*/, 3];
                        case "deactivate": return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 7];
                case 1: return [4 /*yield*/, SubscriberService.provision(request)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3: return [4 /*yield*/, SubscriberService.suspend(request)];
                case 4: return [2 /*return*/, _b.sent()];
                case 5: return [4 /*yield*/, SubscriberService.desprovision(request)];
                case 6: return [2 /*return*/, _b.sent()];
                case 7: return [2 /*return*/];
            }
        });
    });
}
function UpdateSubscriber() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var location = useLocation();
    var navigate = useNavigate();
    var auth = useAuth().auth;
    var canEditSubscriber = auth.permissions.includes("update-subscriber");
    var _j = useState([]), servicesAction = _j[0], setServicesAction = _j[1];
    var _k = useState([]), allServices = _k[0], setAllServices = _k[1];
    var _l = useState(), internetSpeedData = _l[0], setInternetSpeedData = _l[1];
    var _m = useState(false), modalConfirmForm = _m[0], setModalConfirmForm = _m[1];
    var servicesData = (_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.services) !== null && _b !== void 0 ? _b : [];
    var _o = useState(false), isInitialized = _o[0], setIsInitialized = _o[1];
    var _p = useState((_c = location.state) === null || _c === void 0 ? void 0 : _c.subscriber), originalSubscriberData = _p[0], setOriginalSubscriberData = _p[1];
    var _q = useState((_d = location.state) === null || _d === void 0 ? void 0 : _d.subscriber), subscriberData = _q[0], setSubscriberData = _q[1];
    var _r = useState([]), emailHistory = _r[0], setEmailHistory = _r[1];
    var _s = useState([]), subscriberHistory = _s[0], setSubscriberHistory = _s[1];
    var _t = useState(false), hasUnsavedChanges = _t[0], setHasUnsavedChanges = _t[1];
    var _u = useState({
        open: false,
        vertical: "top",
        horizontal: "right",
    }), snackBarState = _u[0], setSnackBarState = _u[1];
    var _v = useState(false), openSnackBar = _v[0], setOpenSnackBar = _v[1];
    var _w = useState(false), shakeSnackBar = _w[0], setShakeSnackBar = _w[1];
    function handleSubscriberDataUpdate(data) {
        setSubscriberData(data);
    }
    var hasChanges = function () {
        var _a, _b, _c, _d, _e;
        return (((_a = originalSubscriberData === null || originalSubscriberData === void 0 ? void 0 : originalSubscriberData.name) === null || _a === void 0 ? void 0 : _a.trim()) !== ((subscriberData === null || subscriberData === void 0 ? void 0 : subscriberData.name) || "").trim() ||
            ((_b = originalSubscriberData === null || originalSubscriberData === void 0 ? void 0 : originalSubscriberData.email) === null || _b === void 0 ? void 0 : _b.trim()) !== ((subscriberData === null || subscriberData === void 0 ? void 0 : subscriberData.email) || "").trim() ||
            ((_c = originalSubscriberData === null || originalSubscriberData === void 0 ? void 0 : originalSubscriberData.document) === null || _c === void 0 ? void 0 : _c.trim()) !== ((subscriberData === null || subscriberData === void 0 ? void 0 : subscriberData.document) || "").trim() ||
            ((_d = originalSubscriberData === null || originalSubscriberData === void 0 ? void 0 : originalSubscriberData.phone) === null || _d === void 0 ? void 0 : _d.trim()) !== ((subscriberData === null || subscriberData === void 0 ? void 0 : subscriberData.phone) || "").trim() ||
            ((_e = originalSubscriberData === null || originalSubscriberData === void 0 ? void 0 : originalSubscriberData.customer_plan) === null || _e === void 0 ? void 0 : _e.trim()) !== ((subscriberData === null || subscriberData === void 0 ? void 0 : subscriberData.customer_plan) || "").trim() ||
            (originalSubscriberData === null || originalSubscriberData === void 0 ? void 0 : originalSubscriberData.internet_speed_id) !== (subscriberData === null || subscriberData === void 0 ? void 0 : subscriberData.internet_speed_id));
    };
    function handleDiscard() {
        setSubscriberData(originalSubscriberData);
        setHasUnsavedChanges(false);
        handleCloseSnackBar();
    }
    useEffect(function () {
        if (!location.state) {
            navigate("/subscribers", { replace: true });
        }
    }, [location.state, navigate]);
    useEffect(function () {
        var _a;
        if (!isInitialized) {
            setOriginalSubscriberData((_a = location.state) === null || _a === void 0 ? void 0 : _a.subscriber);
            setIsInitialized(true);
            return;
        }
        var changes = hasChanges();
        if (changes && !snackBarState.open && !openSnackBar) {
            setSnackBarState({
                open: true,
                vertical: "top",
                horizontal: "right",
            });
            setOpenSnackBar(true);
        }
        else if (!changes) {
            if (snackBarState.open) {
                handleCloseSnackBar();
            }
        }
    }, [subscriberData, isInitialized]);
    function handleSave() {
        openModal();
        handleCloseSnackBar();
    }
    function handleCloseSnackBar() {
        setSnackBarState(__assign(__assign({}, snackBarState), { open: false }));
        setOpenSnackBar(false);
        setShakeSnackBar(false);
    }
    function handleOverlayClick() {
        setShakeSnackBar(true);
        setTimeout(function () { return setShakeSnackBar(false); }, 500);
    }
    var action = (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ size: "small", onClick: handleSave, sx: {
                    fontWeight: 400,
                    mr: 1,
                    fontFamily: "Gabarito",
                    color: "#FFF",
                    textTransform: "none",
                } }, { children: "Salvar" })), _jsx(IconButton, __assign({ size: "small", "aria-label": "close", onClick: handleDiscard, sx: { fontSize: "1.2rem" } }, { children: _jsx(CloseIcon, { fontSize: "small", style: { color: "#BFBFBF" } }) }))] }));
    function update() {
        return __awaiter(this, void 0, void 0, function () {
            var subscriberName, updatedDocument, updateResponse, servicesResponse, errorMessage, hasError, _loop_1, _i, servicesAction_1, serviceAction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subscriberName = subscriberData.name.split(" ")[0];
                        updatedDocument = "";
                        updateResponse = "";
                        servicesResponse = "";
                        errorMessage = "";
                        hasError = false;
                        Notification().Loading.dots("Carregando");
                        return [4 /*yield*/, SubscriberService.update(location.state.subscriber.document, subscriberData).then(function (res) {
                                subscriberName = res.data.subscriber.name;
                                updatedDocument = res.data.subscriber.document;
                                updateResponse = "".concat(res.data.response);
                            }, function (err) {
                                hasError = true;
                                handleServiceError(err);
                            })];
                    case 1:
                        _a.sent();
                        if (!hasError) return [3 /*break*/, 2];
                        Notification().Loading.remove();
                        return [3 /*break*/, 7];
                    case 2:
                        _loop_1 = function (serviceAction) {
                            var message, request;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        message = "";
                                        request = {
                                            contentSupplierProduct: serviceAction.content_supplier_product_id,
                                            documents: [updatedDocument],
                                        };
                                        if (!(serviceAction.action === "changed")) return [3 /*break*/, 2];
                                        return [4 /*yield*/, SubscriberService.change(serviceAction.old_service_id, serviceAction.content_supplier_product_id, updatedDocument).then(function (res) {
                                                message = res.data.response.success;
                                            }, function (err) {
                                                if (err.response.status === 422) {
                                                    message = err.response.data.response.error;
                                                }
                                                else if (err.response.status === 409) {
                                                    message = err.response.data.response.error;
                                                }
                                            })];
                                    case 1:
                                        _b.sent();
                                        return [3 /*break*/, 4];
                                    case 2: return [4 /*yield*/, handleAction(serviceAction.action, request).then(function (res) {
                                            message = res.data.response.success;
                                        }, function (err) {
                                            if (err.response.status === 422) {
                                                message = err.response.data.response.error;
                                            }
                                            else if (err.response.status === 409) {
                                                message = err.response.data.response.error;
                                            }
                                        })];
                                    case 3:
                                        _b.sent();
                                        _b.label = 4;
                                    case 4:
                                        servicesResponse += "".concat(message, "<br>");
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _i = 0, servicesAction_1 = servicesAction;
                        _a.label = 3;
                    case 3:
                        if (!(_i < servicesAction_1.length)) return [3 /*break*/, 6];
                        serviceAction = servicesAction_1[_i];
                        return [5 /*yield**/, _loop_1(serviceAction)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6:
                        Notification().Loading.remove();
                        Notification().Report.info("Assinante: ".concat(subscriberName), "".concat(updateResponse, " </br> ").concat(servicesResponse), "Confirmar");
                        navigate("/subscribers");
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    var openModal = function () {
        setModalConfirmForm(true);
    };
    var closeModal = function () {
        setModalConfirmForm(false);
    };
    function deleteSubscriber(subscriber_document) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Loading.dots("Carregando");
                SubscriberService.destroy(subscriber_document).then(function (res) {
                    Notification().Loading.remove();
                    Notification().Notify.success(res.data.response);
                    navigate("/subscribers");
                }, function (err) {
                    Notification().Loading.remove();
                    if (err.response.status === 403) {
                        Notification().Notify.failure("Usuário não tem permissão para executar essa ação!");
                    }
                    else {
                        Notification().Notify.failure(err.response.data.response);
                    }
                });
                return [2 /*return*/];
            });
        });
    }
    function showDeleteConfirmation(subscriber_document) {
        var msg = "Tem certeza que deseja excluir o assinante?";
        Notification().Confirm.show("Confirmação de exclusão", msg, "Não", "Sim", function () { }, function () {
            deleteSubscriber(subscriber_document);
        }, {
            okButtonBackground: "#ccc",
            cancelButtonBackground: "#F44336",
        });
    }
    function formatDateTime(dateTimeFormatted) {
        var _a = dateTimeFormatted.split(" "), datePart = _a[0], timePart = _a[1];
        var _b = datePart.split("/"), day = _b[0], month = _b[1], year = _b[2];
        var _c = timePart.split(":"), hours = _c[0], minutes = _c[1], seconds = _c[2];
        var dateString = "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hours, ":").concat(minutes, ":").concat(seconds);
        var dateTime = new Date(dateString);
        var dateFormatted = dateTime.toLocaleDateString();
        var timeFormatted = dateTime.toLocaleTimeString();
        return { dateFormatted: dateFormatted, timeFormatted: timeFormatted };
    }
    function filterHistory(subscriberHistory, auth) {
        return subscriberHistory.reduce(function (accumulator, current) {
            var isRestrictedUser = auth && (auth.id === 173 || auth.id === 45);
            var serviceContainsAlares = current.service.toLowerCase().includes("alares");
            if (serviceContainsAlares && !isRestrictedUser) {
                return accumulator;
            }
            var lastService = accumulator[accumulator.length - 1];
            if (!lastService || lastService.service !== current.service || ![1, 5, 10].includes(current.token_status_id)) {
                accumulator.push(current);
            }
            else if ([1, 5, 10].includes(current.token_status_id)) {
                accumulator[accumulator.length - 1] = current;
            }
            return accumulator;
        }, []);
    }
    var filteredHistory = filterHistory(subscriberHistory, auth);
    useEffect(function () {
        var _a, _b;
        if (!((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.subscriber) === null || _b === void 0 ? void 0 : _b.id))
            return;
        if (!auth.permissions.includes("view-subscriberEmailHistory"))
            return;
        SubscriberService.getSubscriberEmailHistory(location.state.subscriber.id).then(setEmailHistory, function () { return setEmailHistory([]); });
    }, [(_f = (_e = location.state) === null || _e === void 0 ? void 0 : _e.subscriber) === null || _f === void 0 ? void 0 : _f.id, auth.permissions]);
    useEffect(function () {
        var _a, _b;
        if (!((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.subscriber) === null || _b === void 0 ? void 0 : _b.id))
            return;
        if (!auth.permissions.includes("view-subscriberActivityReport"))
            return;
        SubscriberService.getSubscriberHistory(location.state.subscriber.id).then(function (res) { return setSubscriberHistory(res.data.histories.data); }, function () { return setSubscriberHistory([]); });
    }, [(_h = (_g = location.state) === null || _g === void 0 ? void 0 : _g.subscriber) === null || _h === void 0 ? void 0 : _h.id, auth.permissions]);
    if (!location.state) {
        return null;
    }
    var breadcrumbsItens = [
        {
            name: "Gerenciar assinantes",
            route: "/subscribers",
        },
        {
            name: "".concat(location.state.subscriber.name),
            route: "/subscribers/new",
        },
    ];
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsx(Title, { text: "".concat(location.state.subscriber.name), hr: false }), _jsx(Breadcrumbs, { itens: breadcrumbsItens }), _jsx("div", __assign({ className: "notice-about-adding-service" }, { children: _jsxs("p", __assign({ className: "mb-0" }, { children: ["Para gerenciar os servi\u00E7os do assinante ", _jsx("strong", { children: location.state.subscriber.name }), ", retorne \u00E0 p\u00E1gina de", " ", _jsx(Link, __assign({ to: "/subscribers?document=".concat(location.state.subscriber.document), className: "link-to-subscriber" }, { children: "Gerenciar Assinantes" })), ". Em seguida, selecione o assinante desejado e clique no menu de a\u00E7\u00F5es para escolher o servi\u00E7os que voc\u00EA deseja adicionar a ele."] })) })), _jsxs("div", __assign({ className: "container-subscriber" }, { children: [_jsx(SubscriberForm, { subscriberData: subscriberData, callbackSubscriberData: handleSubscriberDataUpdate, callbackInternetSpeedData: setInternetSpeedData, callbackSubscriberDataUpdate: handleSubscriberDataUpdate, disabled: !canEditSubscriber }), _jsx(ConfirmForm, { servicesAction: servicesAction, subscriberData: subscriberData, internetSpeedData: internetSpeedData, callbackAction: update, show: modalConfirmForm, closeModal: closeModal })] })), _jsx(Can, __assign({ permission: "view-subscriberActivityReport" }, { children: _jsx(HistoryTable, { title: "Relat\u00F3rio de Atividades", emptyMessage: "Nenhum hist\u00F3rico de atividades dispon\u00EDvel.", rows: filteredHistory !== null && filteredHistory !== void 0 ? filteredHistory : [], columns: [
                        {
                            label: "Data",
                            className: "col-3 titles-table-subscriber-activity",
                            style: { paddingLeft: "2rem", paddingBlock: "1.5rem" },
                        },
                        {
                            label: "Hora",
                            className: "col-2 titles-table-subscriber-activity",
                            style: { paddingBlock: "1.5rem" },
                        },
                        {
                            label: "Ocorrência",
                            className: "col-4 titles-table-subscriber-activity",
                            style: { paddingLeft: "2rem", paddingBlock: "1.5rem" },
                        },
                        {
                            label: "Serviço",
                            className: "col-3 titles-table-subscriber-activity",
                            style: { paddingBlock: "1.5rem" },
                        },
                    ], renderRow: function (subscriber, index) {
                        var _a = formatDateTime(subscriber.date), dateFormatted = _a.dateFormatted, timeFormatted = _a.timeFormatted;
                        var statusConfig = getTokenStatusConfigById(subscriber.token_status_id);
                        return (_jsxs("tr", { children: [_jsx("td", __assign({ className: "line-infos-subscriber-activity text-start", style: {
                                        paddingLeft: "2rem",
                                        paddingBlock: "1.5rem",
                                    } }, { children: dateFormatted })), _jsx("td", __assign({ className: "line-infos-subscriber-activity text-start", style: {
                                        paddingBlock: "1.5rem",
                                    } }, { children: timeFormatted })), _jsx("td", __assign({ className: "line-infos-subscriber-activity", style: {
                                        paddingLeft: "2rem",
                                        paddingBlock: "1.5rem",
                                    } }, { children: _jsxs("div", __assign({ className: "d-flex gap-1" }, { children: [_jsx(MuiIcon, { iconName: statusConfig.iconName, iconColor: statusConfig.iconColor }), _jsx("span", { children: subscriber.token_status_translation })] })) })), _jsx("td", __assign({ className: "line-infos-subscriber-activity text-start", style: {
                                        paddingBlock: "1.5rem",
                                    } }, { children: subscriber.service }))] }, index));
                    } }) })), _jsx(Can, __assign({ permission: "view-subscriberEmailHistory" }, { children: _jsx(HistoryTable, { title: "Hist\u00F3rico de Envios", emptyMessage: "Nenhum hist\u00F3rico de envios dispon\u00EDvel.", wrapperStyle: { marginTop: "1.5rem" }, rows: emailHistory, columns: [
                        { label: "Data", style: { width: "15%", paddingLeft: "2rem", paddingBlock: "1.5rem" } },
                        { label: "Hora", style: { width: "12%", paddingBlock: "1.5rem" } },
                        { label: "Ocorrência", style: { width: "20%", paddingLeft: "2rem", paddingBlock: "1.5rem" } },
                        { label: "E-mail", style: { width: "30%", paddingBlock: "1.5rem" } },
                        { label: "Serviço", style: { width: "23%", paddingBlock: "1.5rem" } },
                    ], renderRow: function (entry, index) {
                        var statusColor = getEmailStatusColor(entry.status_name);
                        var isError = EMAIL_ERROR_STATUS.includes(entry.status_name);
                        return (_jsxs("tr", { children: [_jsx("td", __assign({ className: "line-infos-subscriber-activity text-start", style: { paddingLeft: "2rem", paddingBlock: "1.5rem" } }, { children: entry.date })), _jsx("td", __assign({ className: "line-infos-subscriber-activity text-start", style: { paddingBlock: "1.5rem" } }, { children: entry.time })), _jsx("td", __assign({ className: "line-infos-subscriber-activity", style: { paddingLeft: "2rem", paddingBlock: "1.5rem" } }, { children: _jsxs("div", __assign({ className: "d-flex gap-1" }, { children: [_jsx(MuiIcon, { iconName: isError ? "ErrorRounded" : "CheckCircleRounded", iconColor: statusColor }), _jsx("span", __assign({ style: { color: statusColor } }, { children: entry.status_name }))] })) })), _jsx("td", __assign({ className: "line-infos-subscriber-activity text-start", style: { paddingBlock: "1.5rem" } }, { children: entry.recipient_email })), _jsx("td", __assign({ className: "line-infos-subscriber-activity text-start", style: { paddingBlock: "1.5rem" } }, { children: entry.product_name }))] }, index));
                    } }) })), _jsxs("div", __assign({ className: "container-settings container-subscriber", style: { marginTop: "1.5rem" } }, { children: [_jsx("h3", { children: "Configura\u00E7\u00F5es" }), _jsx("div", __assign({ className: "settings-actions" }, { children: _jsx(Can, __assign({ permission: "delete-subscriber" }, { children: _jsxs("button", __assign({ type: "button", onClick: function () { return showDeleteConfirmation(subscriberData.document); } }, { children: [_jsx(DeleteOutlineOutlinedIcon, {}), _jsx("p", { children: "Excluir Assinante" })] })) })) }))] })), _jsx(Snackbar, { anchorOrigin: {
                    vertical: snackBarState.vertical,
                    horizontal: snackBarState.horizontal,
                }, open: snackBarState.open, className: shakeSnackBar ? "snackbar-shake" : "", message: "Salvar altera\u00E7\u00F5es?", action: action, sx: {
                    zIndex: 9999999,
                    fontFamily: "Nunito Sans, sans-serif",
                    fontWeight: 400,
                }, onClose: handleCloseSnackBar }, snackBarState.vertical + snackBarState.horizontal), _jsx(Overlay, { isOpen: openSnackBar, onClose: handleCloseSnackBar, onClick: handleOverlayClick })] })));
}
export default UpdateSubscriber;
